// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"268":"events","472":"settings","671":"services","861":"myvb","887":"apps","946":"news"}[chunkId] + "." + {"268":"4db4a135","472":"3cf7be0e","671":"36907472","861":"15a20e31","887":"db06765a","946":"d8155945"}[chunkId] + ".css";
};